export const SESSION_KEYS = {
    SHARED_CALENDAR: 'sharedCalendar',
    SELECTED_CALENDAR: 'selectedCalendar',
    USER_CALENDAR_IDS: 'userCalendarIds',
};